import { render, staticRenderFns } from "./buses.vue?vue&type=template&id=5af7ec47&scoped=true&"
import script from "./buses.vue?vue&type=script&lang=js&"
export * from "./buses.vue?vue&type=script&lang=js&"
import style0 from "./buses.vue?vue&type=style&index=0&id=5af7ec47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af7ec47",
  null
  
)

export default component.exports